import React, { useEffect, useState } from "react";
import { FaArrowUp } from 'react-icons/fa';

const TopBar = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (scrollTop / docHeight) * 100;

      setScrollProgress(scrolled);
      setIsVisible(scrollTop > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* Top Scroll Progress Bar */}
      <div
        className="fixed top-0 left-0 h-1 bg-[#113B98] z-50 transition-all duration-200"
        style={{ width: `${scrollProgress}%` }}
      ></div>

      {/* Scroll-to-top Button with Circular Progress */}
      {isVisible && (
        <div
          className="fixed bottom-20 right-6 z-50 w-14 h-14 rounded-full flex items-center justify-center"
          style={{
            background: `conic-gradient(#113B98 ${scrollProgress}%, #e5e7eb ${scrollProgress}%)`,
          }}
        >
          <button
            onClick={scrollToTop}
            aria-label="Scroll to top"
            className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-md hover:bg-gray-100 transition duration-300"
          >
            {/* Unicode Arrow Symbol ↑ */}
            <span className="text-xl font-bold text-[#113B98] leading-none">
              {/* 🡅 */}
                <FaArrowUp />
            </span>
          </button>
        </div>
      )}
    </>
  );
};

export default TopBar;
